import styled from 'styled-components'
import { colors } from "../../styles/colors";

interface IButton{
    type?: string,
    disable?: boolean,
    second?:boolean,
    width?:number,
}

export const Button = styled.button<IButton>`
    width: ${({ width }) => width ? `${ width }px` : '100%'};
    height: 40px;
    padding: 0 11px;
   
    border-radius: 6px;
    border: 2px solid ${ colors.greenDarkViveo };

    margin: 0 !important;

    font-size: calc(10.2564px + 0.12vw);
    user-select: none;

    ${
        ({ second })=> second 
        ? ({ disable }) => disable
            ? `
                border: 2px solid #BCBCBC;;
                background-color: #FFF;
                color: #BCBCBC;
                cursor: not-allowed;
            `
            :
            ` 
                background-color: #FFF;
                color: ${ colors.greenDarkViveo };
            `
        : ({ disable }) => disable
            ? `
                border: 2px solid #BCBCBC;;
                background-color: #FFF;
                color: #BCBCBC;
                cursor: not-allowed;
            `
            :
            `
                background-color: ${ colors.greenDarkViveo };
                color: #FFF;
            `
    }

    :hover{
        opacity: ${ ({ disable }) => !disable && 0.9 }
    }
`

export const ButtonSecond = styled.button`
    width: 100%;
    height: 40px;
    padding: 0 11px;
    background-color: #FFF;
    border: 2px solid ${ colors.greenDarkViveo };
    border-radius: 6px;

    font-size:  calc(10.2564px + 0.12vw);
    color:  ${ colors.greenDarkViveo };
    font-weight: 700;
`